import React, { Suspense } from 'react';

import NotFound from 'pages/NotFound';
import { Loader } from 'components/Base';

import { useLayoutLoading } from 'utils/useLayoutLoading';
import { usePrequalificationData } from 'utils/usePrequalificationData';
import { usePrequalificationStep } from 'utils/usePrequalificationStep';
import { PrequalificationGetResponseType } from 'api/rtkQueryApi';
import { PreQualificationStep } from 'handlers/stages';

const Offers = React.lazy(() => import('./steps/Offers'));
const CreateAccount = React.lazy(() => import('./steps/CreateAccount'));
const EmailVerification = React.lazy(() => import('./steps/EmailVerification'));

const componentByPreQualificationStep = {
  [PreQualificationStep.Offers]: Offers,
  [PreQualificationStep.CreateAccount]: CreateAccount,
  [PreQualificationStep.EmailVerification]: EmailVerification,
};

export interface PreQualificationStepProps {
  preQualificationData: PrequalificationGetResponseType['data'];
}

const PreQualificationProcess = () => {
  const { preQualification, isFetching, isLoading, applicationId } = usePrequalificationData();
  const { preQualificationStep } = usePrequalificationStep(preQualification);

  useLayoutLoading(isLoading, isFetching);

  if (!applicationId) {
    return <NotFound />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (!preQualification) {
    return <NotFound />;
  }

  const Component = preQualificationStep ? componentByPreQualificationStep[preQualificationStep] : null;

  if (!Component) {
    return <NotFound />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Component preQualificationData={preQualification} />
    </Suspense>
  );
};

export default PreQualificationProcess;
